import React, { Component } from 'react'

import Reward from '../Reward'

export default class extends Component {
  render() {
    const { isShow, rewardList, roomRewardList, topBg, centerBg, bottomBg } = this.props
    return (
      <div className="nt-reward-part-wrap" style={{ display: `${isShow ? 'block' : 'none'}` }}>
        {rewardList &&
          rewardList.map((item, index) => {
            return (
              item &&
              item.list.length > 0 && (
                <Reward
                  topBg={topBg}
                  centerBg={centerBg}
                  bottomBg={bottomBg}
                  key={index}
                  title={item.title}
                  list={item.list}
                />
              )
            )
          })}
        {roomRewardList &&
          roomRewardList.map((item, index) => {
            if (index == 0) {
              return (
                item &&
                item.list.length > 0 && (
                  <Reward
                    topBg={topBg}
                    centerBg={centerBg}
                    bottomBg={bottomBg}
                    key={index}
                    title={'Room Medal'}
                    list={item.list}
                  />
                )
              )
            }
          })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/RewardPart/index.js